import { motion } from 'framer-motion';

import CleanLinkButton from '../../../../../components/CleanLinkButton/CleanLinkButton';
import Row from '../../../../../components/Row/Row';
import SVG from '../../../../../components/SVG/SVG';
import filterObjectProperties from '../../../../../helpers/objects/filterObjectProperties';
import BookingParameters from '../../../../types/BookingParameters';
import ComposeBookingStep from '../../../../types/ComposeBookingStep';
import dateIcon from '../../graphics/dateIcon.svg?raw';
import dockIcon from '../../graphics/dockIcon.svg?raw';
// import boatModelIcon from '../../graphics/boatModelIcon.svg?raw';
import passengersIcon from '../../graphics/passengersIcon.svg?raw';
import compileStepUrl from '../../helpers/compileStepUrl';
import ComposeBookingStepsUrls from '../../types/ComposeBookingStepsUrls';

import styles from './StepsNavigation.module.css';

const stepsAndIcons = {
    dock: dockIcon,
    passengers: passengersIcon,
    pickupDate: dateIcon,
} as const;

type AvailableKeys = keyof typeof stepsAndIcons;

type StepButtonProps = {
    icon: string;
    href?: string;
};

const StepButton = ({ icon, href }: StepButtonProps) => {
    return (
        <CleanLinkButton
            href={href}
            className={styles.Button}
            fullWidth
            visitOptions={{
                preserveScroll: true,
            }}
        >
            <SVG src={icon} className={styles.Icon} />
        </CleanLinkButton>
    );
};

type StepsNavigationProps = {
    currentStep: ComposeBookingStep;
    stepUrls: ComposeBookingStepsUrls;
    parameters: BookingParameters;
    noPassengers?: boolean;
};

const StepsNavigation = ({
    currentStep,
    stepUrls,
    parameters,
    noPassengers = false,
}: StepsNavigationProps) => {
    const steps = filterObjectProperties(stepsAndIcons, (key) => {
        return !(key === 'passengers' && noPassengers);
    });

    const stepIndex = Object.keys(steps).indexOf(currentStep);

    const numSteps = Object.keys(steps).length;

    return (
        <div>
            <Row space="none">
                {Object.keys(steps).map((stepKey) => {
                    const typedStep = stepKey as AvailableKeys;

                    return (
                        <StepButton
                            key={typedStep}
                            icon={steps[typedStep]!}
                            href={compileStepUrl(
                                typedStep,
                                stepUrls,
                                parameters
                            )}
                        />
                    );
                })}
            </Row>

            <div className={styles.Bar}>
                <motion.div
                    className={styles.Highlight}
                    animate={{
                        left: `${(stepIndex * 100) / numSteps}%`,
                        width: `${100 / numSteps}%`,
                    }}
                    transition={{ ease: 'circOut' }}
                />
            </div>
        </div>
    );
};

export default StepsNavigation;
